export class SscRequest {
    public aModule: string;
    public aId: string;
    public aFunction: string;
    public aUModule: string;
    public aUId: string;
    public aUFunction: string;
    public aJwt: string;
    public aData: any;

    public getConcatModule(): string {
        let tmp: string = this.aModule;
        if (this.aUModule != null) {
            tmp += `.${this.aUModule}`;
        }
        return tmp;
    }

    public getConcatId(): string {
        let tmp: string = '';
        if (this.aId != null) {
            tmp = this.aId;
        } else {
            tmp = '-';
        }

        if (this.aUId != null) {
            tmp += `.${this.aUId}`;
        }
        return tmp;
    }

    public getConcatFunction(): string {
        let tmp: string = this.aFunction || '';
        if (this.aUFunction != null) {
            if (this.aFunction != null) {
                tmp += '.';
            }
            tmp += this.aUFunction;
        }
        return tmp;
    }

}
